const DEFAULT_WIZARD_ERROR =
  "Search is temporarily unavailable. Please try again.";

export function requireSuccessfulWizardResponse(response) {
  if (response && response.status === true) {
    return response;
  }

  const message =
    (response && response.error && response.error.message) ||
    (response && response.message) ||
    DEFAULT_WIZARD_ERROR;
  const error = new Error(message);
  error.code =
    (response && response.error && response.error.code) ||
    "wizard_search_unavailable";
  throw error;
}

export function showWizardSearchError(component, error) {
  component.loader = false;
  component.loading = false;
  component.$swal.fire(
    "Search unavailable",
    (error && error.message) || DEFAULT_WIZARD_ERROR,
    "error"
  );
}
